
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tv",
      function () {
        return require("private-next-pages/tv/index.tsx");
      }
    ]);
  